export default __webpack_public_path__ + "static/medal-konkurs-1241e64b3cbf26336c6d5c4d10eae4cd.png";